<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>BA Form</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="pink lighten-1" dark @click="openMailDialog" small>
  <v-icon left>email</v-icon> Mail Gönder
</v-btn>
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile @click="getListExcelE()">
                    <v-list-tile-title>{{ $t('Excel-E-Agreement-Download') }} </v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
<!-- MAIL GÖNDER DIALOG -->
<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>Mail Gönder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>
 
    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              label="Kime (e-posta)"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>
 
          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              label="Agency Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>
 
          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              label="Doc Type (sabit)"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>
 
          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              label="Agent Full Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>
 
          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              label="Mesaj"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
 
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>Gönder
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
 
 
          <v-container fluid>
            <v-layout row wrap>



              <v-flex xs12 sm6 md6 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">add_comment</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ToplamAdet}}

                                </span>
                              </v-list-tile-title>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> {{$t('totalnumber')}}</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md6 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{GenelDipToplam | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> {{ $t('Grand-Total') }} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


            </v-layout>
          </v-container>

          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout align-center="">
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout align-center="">
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>



                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>

                          <v-flex xs12 md12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headersbs" :rows-per-page-items=[20,100] :items="itemsbs"
                                :search="searchsatilanbilet">

                                <template slot="items" slot-scope="props">
                                  <tr item>
                                    <td class="text-xs-left">{{ props.item.Unvan }}</td>
                                    <td class="text-xs-left">{{ props.item.Ulke }}</td>
                                    <td class="text-xs-left">{{ props.item.VergiNo }}</td>
                                    <td class="text-xs-left">{{ props.item.TckimlikNo}}</td>
                                    <td class="text-xs-right">{{ props.item.ToplamAdet}}</td>
                                    <td class="text-xs-right">{{ props.item.KdvsizToplam | moneyformat}}</td>
                                    <v-btn @click="postagonder(props.item)" icon class="mx-0">
                                      <v-icon color="green">email</v-icon>
                                    </v-btn>
                                  </tr>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                  {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">


                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">
                            <v-flex xs12 sm12 md12>
                                <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="Rapor.Cari.Kod" :loading="loading" 
                                  v-model="Rapor.Cari.Kod" ></cariaracomp>
                            </v-flex>
                            <v-flex xs12 sm6 md12>
                              <v-autocomplete hide-details="" clearable :items="hesapgurubu"
                                :label="$t('Account-Group-Requested')" multiple item-text="Title" v-model="Rapor.Gruplar"
                                item-value="Kod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <div v-if="index === 0">
                                    <span>{{ item.Title }}</span>
                                  </div>
                                  <span v-if="index === 1" class="grey--text caption">&nbsp;(+{{
                                                                Rapor.Gruplar.length -
                                                                1
                                                                }} {{ $t('Other') }})</span>
                                </template>
                              </v-autocomplete>
                            </v-flex>

                            <v-flex xs12 sm6 md12>
                              <v-autocomplete hide-details="" clearable :items="hesapgurubu"
                                :label="$t('Account-Group-Not-Requested')" multiple item-text="Title" v-model="Rapor.NoGruplar"
                                item-value="Kod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <div v-if="index === 0">
                                    <span>{{ item.Title }}</span>
                                  </div>
                                  <span v-if="index === 1" class="grey--text caption">&nbsp;(+{{
                                                                Rapor.NoGruplar.length -
                                                                1
                                                                }} {{ $t('Other') }})</span>
                                </template>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm12 md12>

                              <parainput :etiket="$t('Limit')" :simge="getparabirimi()" v-model="Rapor.Limit"
                                :autocomplete="'autocomplete'">
                              </parainput>
                            </v-flex>


                            <v-flex xs12 sm12 md12>

                              <v-checkbox :label="$t('Limit-Tax-Number')" v-model="Rapor.LimitVergiNo" hide-details="">
                              </v-checkbox>
                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-checkbox :label="$t('Deduct-Commission-Amount')" v-model="Rapor.KomisyonTutarDus" hide-details="">
                              </v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm12 md12>

                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-flex>


                            <v-flex xs12 sm12 md12>

                              <v-radio-group v-model="Rapor.Program" hide-details>
                                <v-radio value="0" :label="$t('All')"></v-radio>
                                <v-radio value="1" :label="$t('Only-Ticket-Documents')"></v-radio>
                                <v-radio value="2" :label="$t('Documents-Other-Than-Ticket')"></v-radio>
                              </v-radio-group>

                            </v-flex>

                            <v-flex xs12 sm12 md12>


                              <v-radio-group v-model="Rapor.BiletEvrak" hide-details>
                                <v-radio value="0" :label="$t('All')"></v-radio>
                                <v-radio value="1" :label="$t('Domestic-Line')"></v-radio>
                                <v-radio value="2" :label="$t('International-Line')"></v-radio>
                              </v-radio-group>
                            </v-flex>



                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import parainput from "@/components/app/customcomp/parainput.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp'

  export default {
    data() {
      return {
        mailDialog: false,
mailValid: false,
mailLoading: false,
mailPayload: {
  To: "",
  AgencyName: "",
  DocType: "BA Formu - BA Form",
  AgentFullName: "",
  CustomBody: ""
},
rules: {
  required: v => !!v || 'Zorunlu alan',
  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'
},
 
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        hesapgurubu: [],

        filtrevarmi: false,
        ToplamAdet: 0,
        GenelDipToplam: 0,
        search: '',
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,
        headersbs: [{
            text: this.$t('Title_label'),
            value: 'Unvan',
            align: 'left'
          },
          {
            text: 'Ülkesi',
            value: 'Ulke',
            align: 'left'
          },
          {
            text: this.$t('Tax-No'),
            value: 'VergiNo',
            align: 'left'
          },
          {
            text: this.$t('Identitynumber_label'),
            value: 'TckimlikNo',
            align: 'left'
          },
          {
            text: this.$t('Number-of-Documents'),
            value: 'genel.ToplamAdet',
            align: 'left'
          },
          {
            text: this.$t('Total-Excluding-VAT'),
            value: 'KdvsizToplam',
            align: 'left'
          }
        ],
        satisIc: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        satisDis: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        satisGen: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        iadeic: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,
        },

        iadeDis: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        iadeGen: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        genic: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,
        },

        gendis: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        gengen: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,
        },


        Rapor: {
          SirketKodu: null,
          Cari: {
            Kod: null,
          },
          Gruplar: [],
          NoGruplar: [],
          BaslangicTarih: null,
          BitisTarih: null,
          Limit: 5000,
          LimitVergiNo: false,
          Program: '0', // 0 : Hepsi, 1 : Sadece bilet Evrakları, 2 : Bilet dışı evraklar
          BiletEvrak: '0', // 0 : hepsi, 1 : iç hat, 2 : dış hat
          KomisyonTutarDus: false,
          CariHYKod: null,
        },


        RaporInput: {
          SirketKodu: null,
          Cari: {
            Kod: null,
          },
          BaslangicTarih: null,
          BitisTarih: null,
          Limit: 5000,
          LimitVergiNo: false,
          Program: '0', // 0 : Hepsi, 1 : Sadece bilet Evrakları, 2 : Bilet dışı evraklar
          BiletEvrak: '0', // 0 : hepsi, 1 : iç hat, 2 : dış hat
          KomisyonTutarDus: false,
          CariHYKod: null,
        },

        itemsairlinelist: [],
        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        valid: true,
        tumsirketler: '',
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemsbs: [],
        itemsiade: [],
        itemsvoid: [],


        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      parainput,
      yetkidialog,
      cariaracomp
    },
    watch: {
    },
    methods: {
      getparabirimi() {
        return helpers.getparabirimi()
      },
      postagonder(v) {

        this.RaporInput = this.Rapor
        this.RaporInput.CariHYKod = v.genel.CariHyolKod

        var params = this.RaporInput

        this.$http.post(auth.API_URL + 'api/Report/BAFormLetterHtml', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          var blob = new Blob([response.data], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "BAMutabakatMektubu.html";
          link.click();
          this.RaporInput.CariHYKod = null

        }, (response) => {
          if (response.status === 0) {
            this.RaporInput.CariHYKod = null

            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.RaporInput.CariHYKod = null

            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      getListExcelE: getListExcelE,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      openMailDialog,
      closeMailDialog,
      sendMail
    }
  }

  function openMailDialog() {
  if (!this.mailPayload) this.mailPayload = {};
  this.mailPayload.DocType = "BA Formu - BA Form";
  if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {
    this.$refs.mailForm.resetValidation();
  }
  this.mailDialog = true;
}

function closeMailDialog() {
  this.mailDialog = false;
}

function sendMail() {
  if (!(this.$refs && this.$refs.mailForm && this.$refs.mailForm.validate && this.$refs.mailForm.validate())) return;
  if (!(this.$refs && this.$refs.formgunluksatis && this.$refs.formgunluksatis.validate && this.$refs.formgunluksatis.validate())) return;
  if (!this.Rapor || !this.Rapor.BaslangicTarih || !this.Rapor.BitisTarih) {
    this.text1 = this.$t('Please-select-a-date');
    this.snackbar = true;
    return;
  }
  var credentialsRaw = window.localStorage.getItem('credentials');
  var credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};
  var companyCode = this.tumsirketler === true ? '0' : (credentials && credentials.SirketKodu ? credentials.SirketKodu : null);
  var R = this.Rapor || {};
  var inputObj = {
    SirketKodu: companyCode,
    Cari: { Kod: R.Cari && R.Cari.Kod ? R.Cari.Kod : null },
    Gruplar: Array.isArray(R.Gruplar) ? R.Gruplar : [],
    NoGruplar: Array.isArray(R.NoGruplar) ? R.NoGruplar : [],
    BaslangicTarih: R.BaslangicTarih || null,
    BitisTarih: R.BitisTarih || null,
    Limit: typeof R.Limit === "number" ? R.Limit : 5000,
    LimitVergiNo: !!R.LimitVergiNo,
    Program: R.Program != null ? R.Program : '0',
    BiletEvrak: R.BiletEvrak != null ? R.BiletEvrak : '0',
    KomisyonTutarDus: !!R.KomisyonTutarDus,
    CariHYKod: R.CariHYKod || null
  };
  var mp = this.mailPayload || {};
  var fallbackDocType = "BA Formu - BA Form";
  var mailObj = {
    To: mp.To ? mp.To : "",
    AgencyName: mp.AgencyName ? mp.AgencyName : "",
    DocType: mp.DocType ? mp.DocType : fallbackDocType,
    AgentFullName: mp.AgentFullName ? mp.AgentFullName : "",
    CustomBody: mp.CustomBody ? mp.CustomBody : ""
  };
  var payload = { Input: inputObj, Mail: mailObj };
  this.mailLoading = true;
  var endpoint = auth.API_URL + 'api/Report/MailGonderBaFormExcel';
  this.$http.post(endpoint, payload, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } })
  .then(() => {
    this.mailLoading = false;
    this.mailDialog = false;
    this.text1 = this.$t ? this.$t('Email-sent') : 'Mail gönderildi.';
    this.snackbar = true;
  }, (err) => {
    this.mailLoading = false;
    var body = (err && (err.body || err.data)) ? (err.body || err.data) : {};
    var msg = (body && (body.Message || body.message)) || err.statusText || (this.$t ? this.$t('Email-send-failed') : 'Mail gönderilemedi.');
    this.text1 = msg;
    this.snackbar = true;
  });
}


  function filtrele() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
    this.dialogfiltre = true

  }



  function filtrekayit() {
    this.filtrevarmi = true
    this.getList();
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.dialogfiltre = false
    this.filtrevarmi = false

    this.Rapor.Cari.Kod = null
    this.Rapor.Gruplar = []
    this.Rapor.NoGruplar = []
    this.Rapor.Limit = 5000
    this.Rapor.LimitVergiNo = false
    this.Rapor.Program = '0' // 0 : Hepsi, 1 : Sadece bilet Evrakları, 2 : Bilet dışı evraklar
    this.Rapor.BiletEvrak = '0' // 0 : hepsi, 1 : iç hat, 2 : dış hat
    this.Rapor.KomisyonTutarDus = false
    this.Rapor.CariHYKod = null
    this.getList();
  }

  


  function getList() {

    if (this.$refs.formgunluksatis.validate()) {

      this.ToplamAdet = 0;
      this.GenelDipToplam = 0;

      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/Report/BAFormList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          var liste = [];

          response.body.forEach(element => {

            this.ToplamAdet = this.ToplamAdet + element.ToplamAdet;

            var unvani = null
            var Ulke = null
            var VergiNo = null
            var TckimlikNo = null

            if (element.CariHyol == true) {
              unvani = element.HavayoluDetay.HavaYoluAdi
              Ulke = null
              VergiNo = null
              TckimlikNo = null
            } else {
              unvani = element.Cari.Unvan
              Ulke = element.Cari.FaturaBilgi.Ulke
              VergiNo = element.Cari.FaturaBilgi.VergiNo
              TckimlikNo = element.Cari.FaturaBilgi.TckimlikNo
            }

            var kayit = {
              genel: element,
              Unvan: unvani,
              Ulke: Ulke,
              VergiNo: VergiNo,
              TckimlikNo: TckimlikNo,
              ToplamAdet: element.ToplamAdet,
              KdvsizToplam: element.ToplamGenelToplam - element.ToplamKdv
            }
            this.GenelDipToplam = this.GenelDipToplam + kayit.KdvsizToplam
            liste.push(kayit)
          });

          this.itemsbs = liste

          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }



  function getListHtml() {


    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }


        var params = this.Rapor

        this.$http.post(auth.API_URL + "api/Report/BAFormListHtml", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "BaForm.html";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function getListExcel() {


    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }


        var params = this.Rapor

        this.$http
          .post(auth.API_URL + "api/Report/BAFormListExcel", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            },
            responseType: "arraybuffer"
          }).then((response) => {
            this.progress = false
            this.load1 = true
            var blob = new Blob([response.data], {
              type: 'application/xlsx'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "BaForm.xlsx";
            link.click();
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }

  function getListExcelE() {


    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }


        var params = this.Rapor

        this.$http
          .post(auth.API_URL + "api/Report/BAFormListExcelE", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            },
            responseType: "arraybuffer"
          }).then((response) => {
            this.progress = false
            this.load1 = true
            var blob = new Blob([response.data], {
              type: 'application/xlsx'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "BaForm.xlsx";
            link.click();
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }

  function beforeMount() {

  }
</script>
<style>
</style>